// extracted by mini-css-extract-plugin
module.exports = {"date":"DateInput_date_1AxMY","valid":"DateInput_valid__zNe2","required":"DateInput_required_3saeE"};